import { render, staticRenderFns } from "./AddAttrSpec.vue?vue&type=template&id=1a443f6d&scoped=true"
import script from "./AddAttrSpec.vue?vue&type=script&lang=js"
export * from "./AddAttrSpec.vue?vue&type=script&lang=js"
import style0 from "./AddAttrSpec.vue?vue&type=style&index=0&id=1a443f6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a443f6d",
  null
  
)

export default component.exports